import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { RiAndroidLine, RiAppleLine, RiUser3Line, RiBarChart2Line } from 'react-icons/ri';
import CountUp from 'react-countup';

const Widget = ({ title, value, valueSuffix, percentage, percentageType, icon }) => {
    const renderIcon = () => {
        switch (icon) {
            case 'android':
                return <RiAndroidLine className="text-info" />;
            case 'apple':
                return <RiAppleLine className="text-info" />;
            case 'users':
                return <RiUser3Line className="text-info" />;
            case 'bar-chart-2':
                return <RiBarChart2Line className="text-info" />;
            default:
                return <RiUser3Line className="text-info" />;
        }
    };

    return (
        <Card className="card-animate">
            <CardBody>
                <div className="d-flex justify-content-between">
                    <div>
                        <p className="fw-medium text-muted mb-0">{title}</p>
                        <h2 className="mt-4 ff-secondary fw-semibold">
                            <span className="counter-value">
                                <CountUp start={0} end={value} duration={4} />
                            </span>
                            {valueSuffix}
                        </h2>
                        <p className="mb-0 text-muted">
                            <span className={`badge bg-light text-${percentageType} mb-0`}>
                                <i className={`ri-arrow-${percentageType === 'success' ? 'up' : 'down'}-line align-middle`}></i> {percentage} %
                            </span> vs. previous month
                        </p>
                    </div>
                    <div>
                        <div className="avatar-sm flex-shrink-0">
                            <span className="avatar-title bg-info-subtle rounded-circle fs-2">
                                {renderIcon()}
                            </span>
                        </div>
                    </div>
                </div>
            </CardBody>
        </Card>
    );
};

export default Widget;
